App.vue.setComponent(require('../components/sliders/MainSlider').default);
App.vue.setComponent(require('../components/Banners/WriteAboutUsBanner').default);
App.vue.setComponent(require('../components/Banners/MainPageCategoriesBanner').default);
App.vue.setComponent(require('../components/Banners/MainBannerDual').default);
App.vue.setComponent(
  require('../components/sliders/MainSliderActivities/MainSliderActivities.vue').default
);
App.vue.setComponent(require('../components/sliders/NewProducts.vue').default);
App.vue.setComponent(require('../components/Trends/BeInTrend.vue').default);
App.vue.setComponent(require('../components/sliders/CollectionLook.vue').default);
App.vue.setComponent(require('../components/sliders/InstagramLooks/InstagramLooks.vue').default);
App.vue.setComponent(require('../components/Subscribe/Subscribe.vue').default);
App.vue.setComponent(require('../components/Benefits/Benefits.vue').default);
App.vue.setComponent(require('../components/Seo/SeoText.vue').default);
